
import { ReactNode } from 'react';
import { NoPermission } from '@pages/base-pages/no-permission/NoPermission';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';



interface ProtectedPageProps {
	children: ReactNode,
	requiredRoles: string | string[],
}


export const ProtectedPage = (props: ProtectedPageProps) => {
	const { children, requiredRoles } = props;

	const hasPermission = useHasPermission();

	if (!hasPermission(requiredRoles)) {
		return <NoPermission requiredRoles={requiredRoles} />;
	}

	return <>{children}</>;
}
